module.exports = __webpack_public_path__ + "img/about_elaine_old.a0a278f3.png";